import { PagedList } from 'contensis-core-api';
import { Workflow } from 'contensis-management-api';
import ContensisRepository from '~/repositories/ContensisRepository';
import { Logger } from '~/util/logger';

class WorkflowsService {
  private contensis: ContensisRepository;

  workflows: Workflow[] = [];
  error: AppError | null = null;

  constructor(contensis: ContensisRepository) {
    this.contensis = contensis;
  }

  GetWorkflows = async (): Promise<
    [ApiErrorResponse | null, Workflow[] | undefined]
  > => {
    Logger.info(`Getting workflow definitions from '${this.contensis.alias}'`);

    let workflows: PagedList<Workflow> | undefined;
    [this.error, workflows] = await this.contensis.repo.GetWorkflows();
    if (workflows?.items) this.workflows = workflows.items;

    return [this.error, this.workflows];
  };
}

export default WorkflowsService;
